import { render, staticRenderFns } from "./category-panel-nav-bar-1.vue?vue&type=template&id=45c65d24&"
import script from "./category-panel-nav-bar-1.vue.ts?vue&type=script&lang=ts&"
export * from "./category-panel-nav-bar-1.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports